import type { Logger } from "@expert/logging";
import type { FallbackProps } from "react-error-boundary";
import { RenderError } from "./RenderError";

export function createFallbackRender(logger: Logger) {
    return function fallbackRender({ error }: FallbackProps) {
        if (error instanceof Error) {
            logger.error({ error }, `Error Boundary caught an error: '${error.message}'`);
        } else {
            logger.error(`Error Boundary caught an error: '${JSON.stringify(error)}'`);
        }
        return <RenderError error={error as Error | undefined} />;
    };
}
